export default __webpack_public_path__ + "static/media/ic_stop_circle.655d0d5e.svg";